import React from 'react'

export default function Button({ customStyle = '', style = {}, handle, title, children }) {
  return (
    <button className={`main-button ${customStyle}`} style={style} onClick={handle}>
      {title || children}
    </button>
  )
}
